import React, { useState, useEffect } from "react";
import SideBar from "../../SideBar/SideBar";
import styles from "./GameProcess.module.css"; // Импортируем модуль
import Cookies from "js-cookie";
import axios from "axios";

const GameProcessTable = ({ serverIP }) => {
    const [gameData, setGameData] = useState({});
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [employeeNames, setEmployeeNames] = useState([]);

    useEffect(() => {
        const fetchGameData = async () => {
            try {
                setIsLoading(true);
                const selectedGame = Cookies.get('selectedGame');
                const response = await axios.get(`${serverIP}/v1/game/result`, {
                    params: { game_name: selectedGame },
                    headers: { "Content-Type": "application/json" },
                });

                const transformedData = {};
                let names = [];

                // Обрабатываем первую команду для получения списка сотрудников
                if (response.data.length > 0 && response.data[0].workers) {
                    names = response.data[0].workers.map(worker => worker.name);
                    setEmployeeNames(names);
                }

                response.data.forEach(team => {
                    team.workers.forEach(worker => {
                        worker.step_history.forEach(step => {
                            if (!transformedData[step.step]) {
                                transformedData[step.step] = {};
                            }
                            
                            if (!transformedData[step.step][team.name]) {
                                transformedData[step.step][team.name] = {};
                            }

                            transformedData[step.step][team.name][worker.name] = {
                                status: step.status,
                                action: step.action,
                                involvement: step.score
                            };
                        });
                    });
                });

                setGameData(transformedData);
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchGameData();
    }, []);

    const getStatusBackgroundColor = (status) => {
        const statusColors = {
            "Исполнитель": "#FF930A",
            "Оппортунист": "#0171BB",
            "Союзник": "#FFC000",
            "Противник": "#3A3838",
            "Оппозиционер": "#A5A5A5",
        };
        return statusColors[status] || "#0170ba";
    };

    const getStatusColor = (status) => {
        return ["Исполнитель", "Оппортунист", "Противник"].includes(status) 
            ? "#fff" 
            : "#000";
    };

    if (isLoading) return <p>Загрузка данных...</p>;
    if (error) return <p>Ошибка: {error}</p>;

    const steps = Object.keys(gameData).sort((a, b) => 
        parseInt(a.match(/\d+/)) - parseInt(b.match(/\d+/))
    );

    return (
        <div className={styles.steps}>
            <nav className={styles.stepsNav}>
                {steps.map((step, index) => (
                    <button
                        key={step}
                        onClick={() => setCurrentStepIndex(index)}
                        className={currentStepIndex === index ? styles.active : ""}
                    >
                        Шаг {index + 1}
                    </button>
                ))}
            </nav>

            <div className={styles.stepContent}>
                <div className={styles.employeeNames}>
                    <h3 className={styles.teamTitle}>Сотрудники</h3>

                    <div className={styles.teamTable}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Типаж</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employeeNames.map(name => {
                                    return (
                                        <tr key={name}>
                                            <td className={styles.nameRow}>{name}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                {steps[currentStepIndex] && Object.entries(gameData[steps[currentStepIndex]]).map(([teamName, teamData]) => (
                    <div key={teamName} className={styles.teamBlock}>
                        <h3 className={styles.teamTitle}>{teamName}</h3>
                        <div className={styles.teamTable}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Типаж</th>
                                        <th>Активность</th>
                                        <th>Баллы</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {employeeNames.map(name => {
                                        const data = teamData[name] || {};
                                        return (
                                            <tr key={name}>
                                                <td style={{ 
                                                    backgroundColor: getStatusBackgroundColor(data.status),
                                                    color: getStatusColor(data.status)
                                                }}>
                                                    {data.status || "-"}
                                                </td>
                                                <td>{data.action || "-"}</td>
                                                <td>{data.involvement || "0"}</td>
                                            </tr>
                                        );
                                    })}
                                    <tr className={styles.totalRow}>
                                        <td colSpan="2">Итого</td>
                                        <td>
                                            {Object.values(teamData).reduce(
                                                (sum, item) => sum + (Number(item.involvement) || 0),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

function GameProcess({ isAdmin, serverIP }) {
    return (
        <div className="App">
            <SideBar blueGameProcess={{ backgroundColor: "#0170ba", color: "#fff" }} isAdmin={isAdmin} />
            <div style={{ marginTop: "40px" }}>
                <GameProcessTable serverIP={serverIP} />
            </div>
        </div>
    );
}

export default GameProcess;